import { LogStatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/log-status.enum';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

@Component({
  selector: 'app-data-status-latency',
  standalone: true,
  imports: [
    MatIconModule,
    CommonModule
  ],
  templateUrl: './data-status-latency.component.html',
  styleUrl: './data-status-latency.component.scss'
})
export class DataStatusLatencyComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  logStatusEnum = LogStatusEnum;
}
